<template>
	<div class="layout">
		<div class="list-base">
			<div class="list-base-left">
				<Tag color='magenta' size='large' v-show="documentItem.checkState == 1">已创建</Tag>
				<Tag color='red' size='large' v-show="documentItem.checkState == 2">已过账</Tag>
				<Tag color='success' size='large' v-show="documentItem.checkState == 3">已完结</Tag>
				<span class="list-base-left-span">销售退货单：{{documentItem.code}}</span>
			</div>
			<div class="list-base-right">
				<span class="list-base-right-span">
					业务员：
					<span class="span-back-color">{{documentItem.userName}}</span>
				</span>
				<span class="list-base-right-span">
					业务日期：
					<span class="span-back-color">{{documentItem.businessDate}}</span>
				</span>
				<span class="list-base-right-span">
					本单金额：
					<span class="span-back-color">%{{documentItem.originalPrice}}</span>
				</span>
			</div>
		</div>
		<div class='list-module'>
			<div class="div-title">
				<div class="div-title-label">
					基础信息
				</div>
			</div>
			<Row class="div-content-row">
				<Col span="8">单据编号：{{documentItem.code}}</Col>
				<Col span="8">业务日期：{{documentItem.businessDate}}</Col>
				<Col span="8">业务员：{{documentItem.userName}}</Col>
			</Row>
			<Row class="div-content-row">
				<Col span="8">客户：{{documentItem.customerName}}</Col>
				<Col span="8">备注：{{documentItem.note}}</Col>
			</Row>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					商品信息
				</div>
			</div>
			<Table :columns="commodityColumn" :data="documentItem.returnSalesDetailList"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					额外费用
				</div>
			</div>
			<div>
				<span style="padding-left:20px;">
					注：“我方垫付”影响应付款减少；“对方垫付”影响应付款增加；“我方自付”不影响应付款
				</span>
			</div>
			<div>
				<table class="extraCostShowTable">
					<tr v-for="item in documentItem.extraCostInfos">
						<td>{{item.type}}：</td>
						<td>{{item.advancePayWay}}￥{{item.amount}}</td>
						<td>（{{item.payAccount}}）</td>
					</tr>
				</table>
			</div>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					物流信息
				</div>
			</div>
			<Table :columns="logisticsInfoColumn" :data="documentItem.logisticsInfos"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					结算信息
				</div>
			</div>
			<Row class="div-content-row-center">
				<Col span="8">折后金额：<span class="amount-color">{{documentItem.amount}}</span></Col>
				<Col span="8">已收定金：<span class="amount-color">{{documentItem.payAmount}}</span></Col>
				<Col span="8">待收金额：<span
					class="amount-color">{{formatNum(documentItem.amount - documentItem.payAmount)}}</span></Col>
			</Row>
			<div class="div-content-detail">
				<div class="div-content-detail-title">
					付款详情
				</div>
				<div class="div-content-detail-list" v-show="documentItem.payAmount>0">
					<div class="div-content-detail-list-title">定金</div>
					<div class="div-content-detail-list-content">
						<div class="div-content-detail-list-content-item">
							付款日期：
							<span class="span-back-color">
								{{documentItem.businessDate}}
							</span>
						</div>
						<div class="div-content-detail-list-content-item">
							{{documentItem.payWay}}：
							<span class="span-back-color">
								¥&nbsp;{{documentItem.payAmount}}
							</span>
						</div>
					</div>
				</div>
				<div class="div-content-detail-list" v-show="paymentDetail.length>0">
					<div class="div-content-detail-list-title">付款单付款</div>
					<div class="div-content-detail-list-content" v-for="(item,index) in paymentDetail">
						<div class="div-content-detail-list-content-item">
							付款日期：
							<span class="span-back-color">
								{{item.businessDate}}
							</span>
						</div>
						<div class="div-content-detail-list-content-item">
							{{item.paymentList.payWay}}：
							<span class="span-back-color">
								¥&nbsp;{{item.amountUnpaid}}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					附件信息
				</div>
			</div>
			<DocumentFile :fileList='documentItem.fileList' :isShow='true'></DocumentFile>
		</div>
		<div class="list-module" style="display: flex;justify-content: flex-end;">
			<button class="jxyd-button jxyd-primary" title="打印单据" @click="printDocument()">
				<Icon type="md-print" size='18' />
				打印
			</button>
			<button class="jxyd-button jxyd-primary" title="复制单据" @click="copyDocument(documentItem)">
				<Icon type="md-print" size='18' />
				复制
			</button>
		</div>
			<div id="hiprint-printTemplate" class="designer-canvas"></div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import DocumentFile from '@/components/DocumentFile'
	import formatNum from '@/utils/formatNum'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import printMixin from '@/mixins/printMixin' // 引入打印 mixin
	export default {
		name: 'returnsaleslistdetail',
		mixins: [printMixin],
		components: {
			DocumentFile
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					amount: 0,
					deposit: 0,
					returnSalesDetailList: [],
					customerId: '',
					customerName: '',
					customerDiscount: '100',
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					payWay: '',
					checkState: 1, //未审核
					fileList: []
				},
				commodityColumn: [{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 345
					},
					{
						title: '单位',
						key: 'unit',
						width: 130
					},
					{
						title: '规格',
						key: 'format',
						width: 140,
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock(params.index))
						}
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130
					},
					{
						title: '单价',
						key: 'price',
						width: 140
					},
					{
						title: '折扣(%)',
						key: 'discount',
						width: 140
					},
					{
						title: '折后单价',
						key: 'priceAfterDiscount',
						width: 140
					},
					{
						title: '总金额',
						key: 'amount',
						width: 200
					},
					{
						title: '备注',
						key: 'note',
						width: 350,
					}
				],
				paymentDetail: [],
				logisticsInfoColumn: [{
						title: '物流公司',
						key: 'companyName'
					},
					{
						title: '物流单号',
						key: 'code'
					},
					{
						title: '收货人',
						key: 'receiver'
					},
					{
						title: '运费',
						key: 'freight'
					},
					{
						title: '说明',
						key: 'note'
					}
				]
			}
		},

		methods: {
			getReturnSalesList(returnSalesListId) {
				let self = this;
				request.get('/api/ReturnSalesList/GetReturnSalesList', {
					params: {
						id: returnSalesListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						returnSales;
					}
					self.documentItem = response.data;
					self.getPayDetail(self.documentItem.code);
				}).catch(function(error) {})
			},
			getReturnSalesListByCode(returnSalesListCode) {
				let self = this;
				request.get('/api/ReturnSalesList/GetReturnSalesListByCode', {
					params: {
						code: returnSalesListCode
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						returnSales;
					}
					self.documentItem = response.data;
					self.getPayDetail(self.documentItem.code);
				}).catch(function(error) {})
			},
			formatNum(value) {
				// 调用导入的 formatNum 函数
				return formatNum(value);
			},
			getPayDetail(code) {
				let self = this;
				request.get('/api/PaymentList/GetPaymentDetail', {
					params: {
						code: code
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						returnSales;
					}
					self.paymentDetail = response.data;
				}).catch(function(error) {})
			},
			async copyDocument(param) {
				let self = this;
				await this.$Modal.confirm({
					title: "操作警告",
					content: "是否复制单据？",
					async onOk() {
						let result = await request.get('api/ReturnSalesList/GetNextCode', {
							params: {
								prefix: 'XTH'
							}
						});
						if (!result || result.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '获取编号失败'
							});
							return;
						}
						let data = JSON.parse(JSON.stringify(param));
						data.id = 0;
						data.code = result.data;
						data.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
						data.createDate = data.businessDate;
						data.userId = parseInt(localStorage.getItem("userId"));
						data.userName = localStorage.getItem("userName");
						data.creator = parseInt(localStorage.getItem("userId"));
						data.checkState = 1;
						self.dataSubmitAndCheck(data);
					},
					onCancel() {}
				});
			},
			printDocument() {
				const printData = this.formatPrintData([this.documentItem])
				// 使用 mixin 提供的打印方法
				this.printWithTemplate(printData, 'salesReturnList')
			},
			formatPrintData(rawData) {
				// rawData 已经是数组
				if (!Array.isArray(rawData)) {
					console.error('formatPrintData: rawData 不是数组', rawData);
					return [];
				}

				// 辅助函数：添加序号
				const addSerialNo = (arr) => arr.map((item, idx) => ({
					...item,
					serialNo: idx + 1
				}));

				// 辅助函数：安全获取数值
				const safeNumber = (value) => {
					const num = Number(value);
					return isNaN(num) ? 0 : num;
				};

				// 辅助函数：计算合计
				const calcTotals = (arr, fields) => {
					if (!Array.isArray(arr) || arr.length === 0) {
						const emptyTotals = {};
						fields.forEach(f => {
							emptyTotals[f] = 0;
						});
						return emptyTotals;
					}

					const totals = {};
					fields.forEach(f => {
						totals[f] = 0;
					});

					arr.forEach(item => {
						fields.forEach(f => {
							totals[f] += safeNumber(item[f]);
						});
					});

					return totals;
				};

				// 格式化日期
				const formatDate = (dateStr) => {
					if (!dateStr) return '';
					if (dateStr instanceof Date) {
						const year = dateStr.getFullYear();
						const month = String(dateStr.getMonth() + 1).padStart(2, '0');
						const day = String(dateStr.getDate()).padStart(2, '0');
						return `${year}-${month}-${day}`;
					}
					if (typeof dateStr === 'string') {
						// 处理 "2026-03-19 00:00:00" 或 "2026-03-19" 格式
						return dateStr.split(' ')[0];
					}
					return '';
				};

				// 格式化单条销售退货单记录
				const formatSingle = (record) => {
					if (!record) return {};

					// 1. 格式化商品明细（退货商品列表）
					let commodityRaw = (record.returnSalesDetailList || []).map(item => ({
						name: item.name || '',
						format: item.format || '',
						unit: item.unit || '',
						quantity: safeNumber(item.quantity),
						price: safeNumber(item.price),
						discount: safeNumber(item.discount),
						amount: safeNumber(item.amount)
					}));

					// 添加序号
					let commodityDetail = addSerialNo(commodityRaw);

					// 添加合计行
					if (commodityRaw.length > 0) {
						const totals = calcTotals(commodityRaw, ['quantity', 'amount']);
						commodityDetail.push({
							serialNo: '',
							name: '',
							format: '',
							unit: '合计',
							quantity: totals.quantity,
							price: '',
							discount: '',
							amount: totals.amount,
							__style__: {
								fontWeight: 'bold',
								backgroundColor: '#f9f9f9'
							}
						});
					}

					// 2. 格式化额外费用（退货产生的费用）
					let extraCostRaw = (record.extraCostInfos || []).map(item => ({
						type: item.type || '',
						advancePayWay: item.advancePayWay || '',
						payAccount: item.payAccount || '',
						amount: safeNumber(item.amount),
						note: item.note || ''
					}));

					let extraCost = addSerialNo(extraCostRaw);

					// 添加合计行
					if (extraCostRaw.length > 0) {
						const totals = calcTotals(extraCostRaw, ['amount']);
						extraCost.push({
							serialNo: '',
							type: '',
							advancePayWay: '',
							payAccount: '合计',
							amount: totals.amount,
							note: '',
							__style__: {
								fontWeight: 'bold',
								backgroundColor: '#f9f9f9'
							}
						});
					}

					// 返回格式化后的数据
					return {
						code: record.code || '',
						userName: record.userName || '',
						businessDate: formatDate(record.businessDate),
						customerName: record.customerName || '',
						discount: safeNumber(record.customerDiscount) || 100,
						originalPrice: safeNumber(record.originalPrice),
						amount: safeNumber(record.amount),
						payAmount: safeNumber(record.payAmount),
						payWay: record.payWay || '',
						note: record.note || '',
						linkSalesListCode: record.linkSalesListCode || '', // 关联的销售单号
						commodityDetail: commodityDetail,
						extraCost: extraCost
					};
				};

				// 直接返回格式化后的数组
				return rawData.map(record => formatSingle(record));
			},
			getCurrentIStock(index) {
				let commodityInventorys = this.documentItem.returnSalesDetailList[index].commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.documentItem.returnSalesDetailList[index].format) {
						stock += commodityInventorys[i].stock;
					}
				}
				let extraUnits = this.documentItem.returnSalesDetailList[index].commodity.extraUnits;
				if (extraUnits) {
					extraUnits.forEach(item => {
						if (item.unit == this.documentItem.returnSalesDetailList[index].unit) {
							stock = item.conversionRate * stock;
						}
					});
				}
				return formatNum(stock);
			},
			dataSubmitAndCheck(data) {
				let self = this
				request.post('api/ReturnSalesList/EditReturnSalesList', data).then(function(result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败'
						});
						return
					}
					//记录销售退货单操作
					let log = {
						FlowId: result.data,
						Title: '销售退货单日志',
						OperationContent: '创建了此销售退货单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败'
							});
							return;
						}
					}).catch(err => {})
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '复制成功'
					});
				}).catch(err => {})
			},
		},
		watch: {
			'$route.query.returnSalesListId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getReturnSalesList(param);
					}
				}
			},
			'$route.query.returnSalesListCode': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getReturnSalesListByCode(param);
					}
				}
			}
		},
		created: function() {}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.list-base {
		background-color: white;
		padding: 15px;
		overflow: hidden;
	}

	.list-base-left {
		float: left;
		display: flex;
		color: #000;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 100%;
		/* 父元素需要固定高度或其他百分比高度 */
	}

	.list-base-left-span {
		font-size: 18px;
	}

	.list-base-right {
		display: flex;
		float: right;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 36px;
	}

	.list-base-right-span {
		margin-left: 10px;
	}

	.span-back-color {
		color: #000;
	}

	.div-title {
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 20px;
	}

	.div-title-label {
		border-left: 2px solid rgb(255, 106, 127);
		text-indent: 0.5em;
		font-weight: bold;
	}

	.list-module {
		background-color: white;
		margin-top: 20px;
		padding: 15px;
	}

	.div-content-row div {
		padding: 15px;
	}

	.div-content-row-center div {
		padding: 15px;
		text-align: center;
		font-size: 16px;
		color: #000;
		font-weight: bold;
	}

	.amount-color {
		color: rgb(255, 106, 127);
	}

	.div-content-detail {
		margin: 15px;
		background-color: #f8f8f9;
		padding: 20px;
	}

	.div-content-detail-title {
		text-indent: 0.5em;
		font-weight: bold;
		border-bottom: 1px solid #ebeef5;
	}

	.div-content-detail-list {
		margin-top: 10px;
	}

	.div-content-detail-list-title {
		text-indent: 0.5em;
	}

	.div-content-detail-list-content {
		overflow: hidden;
	}

	.div-content-detail-list-content-item {
		float: left;
		width: 30%;
		padding: 10px;
		text-align: center;
	}

	.extraCostShowTable {
		margin-top: 10px;
		color: #000;
	}

	.extraCostShowTable td {
		padding: 5px;
	}
</style>